 // Eşleşme kurallarını tanımlayın
const giftRules = [
  { 
    mainProductId: "44426157752509", // A ürünü
    giftProductId: "44897190838461", // B ürünü (hediye)
    giftName: "Turbo Başlık Ürünü "
  },
  // İstediğiniz kadar eşleşme ekleyebilirsiniz
];

// Sepeti temizleme ekranında olup olmadığımızı kontrol etmek için bayrak
let isCartBeingCleared = false;
// İşlem yapılıyor mu kontrolü için bayrak
let isProcessing = false;

document.addEventListener('DOMContentLoaded', function() {
  // Sayfa yüklendiğinde sepeti kontrol et
  updateCartWithGifts();
  
  // Sepete ürün ekleme form olaylarını dinle
  listenForCartChanges();
});

function listenForCartChanges() {
  // Tüm "sepete ekle" formlarını dinle
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
  
  addToCartForms.forEach(form => {
    form.addEventListener('submit', function() {
      // Form submit olduktan sonra kısa bir gecikmeyle sepeti güncelle
      setTimeout(updateCartWithGifts, 1000);
    });
  });
  
  // Sepetten kaldırma butonlarını izle
  document.addEventListener('click', function(event) {
    // Kaldırma butonu olabilecek elemanları kontrol et
    const target = event.target;
    
    // Kaldırma butonu veya linki tıklandıysa
    if (isRemoveButton(target) || isNearRemoveButton(target)) {
      // Sadece sepet sayfasında olduğumuzu kontrol et
      if (window.location.pathname.includes('/cart')) {
        // Geçici olarak sepet temizleme modunu aç
        isCartBeingCleared = true;
        
        // Kısa bir süre sonra normal moda dön (sepet güncellemesi tamamlandıktan sonra)
        setTimeout(() => {
          isCartBeingCleared = false;
        }, 3000);
      }
    }
  });
  
  // Ajax ile sepet güncellemelerini dinle
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    // Sepet kaldırma veya temizleme isteği mi kontrol et
    if (typeof url === 'string' && 
        (url.includes('/cart/change') || url.includes('/cart/clear'))) {
      // Sepet temizleme modunu aç
      isCartBeingCleared = true;
      
      // İşlem tamamlandıktan sonra normal moda dön
      setTimeout(() => {
        isCartBeingCleared = false;
      }, 3000);
    }
    
    const fetchPromise = originalFetch(url, options);
    
    // Sepet işlemlerinden sonra sepeti kontrol et
    if (typeof url === 'string' && 
        (url.includes('/cart/add') || url.includes('/cart/update') || 
         url.includes('/cart/change'))) {
      // Sadece sepet temizleme modunda değilsek ve hediye ekleme işlemi değilse
      if (!isCartBeingCleared && !url.includes('properties[_hediye_urun]')) {
        setTimeout(updateCartWithGifts, 1000);
      }
    }
    
    return fetchPromise;
  };
}

// Bir elemanın kaldırma butonu olup olmadığını kontrol et
function isRemoveButton(element) {
  if (!element || !element.tagName) return false;
  
  // Kaldırma butonu/linki olabilecek ortak özellikler
  return (
    // Href içeren linkler
    (element.tagName === 'A' && element.href && 
     (element.href.includes('/cart/change') || element.href.includes('remove'))) ||
    // Data öznitelikleri
    (element.dataset && 
     (element.dataset.cartRemove !== undefined || element.dataset.remove !== undefined)) ||
    // Sınıf isimleri
    (element.classList && 
     (element.classList.contains('cart__remove-btn') || 
      element.classList.contains('cart-remove') ||
      element.classList.contains('cart__remove') ||
      element.classList.contains('remove')))
  );
}

// Bir elemanın kaldırma butonuna yakın olup olmadığını kontrol et
function isNearRemoveButton(element) {
  if (!element || !element.tagName) return false;
  
  // Kaldırma butonunun içindeki metin veya simge olabilir
  const parent = element.parentElement;
  if (parent && isRemoveButton(parent)) {
    return true;
  }
  
  // Çıkartma simgesi, X, çöp kutusu gibi yaygın simgeler
  if (element.tagName === 'I' || element.tagName === 'SPAN' || element.tagName === 'SVG') {
    if (element.classList && 
        (element.classList.contains('icon-remove') || 
         element.classList.contains('icon-trash') || 
         element.classList.contains('icon-close'))) {
      return true;
    }
  }
  
  return false;
}

function updateCartWithGifts() {
  // Eğer sepet temizleme modundaysa veya işlem yapılıyorsa, hiçbir şey yapma
  if (isCartBeingCleared || isProcessing) {
    return;
  }
  
  isProcessing = true;
  
  // Mevcut sepeti al
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Hediye olarak eklenecek ürünleri takip et
      const actionsNeeded = [];
      
      // Her bir hediye kuralını kontrol et
      giftRules.forEach(rule => {
        // Ana ürün sepette mi?
        const mainProductInCart = cart.items.find(item => 
          (item.product_id && item.product_id.toString() === rule.mainProductId) || 
          (item.variant_id && item.variant_id.toString() === rule.mainProductId)
        );
        
        // Hediye ürün sepette mi?
        const giftProductInCart = cart.items.find(item => 
          item.variant_id && 
          item.variant_id.toString() === rule.giftProductId && 
          item.properties && 
          item.properties._hediye_icin === rule.mainProductId
        );
        
        // Ana ürün sepette ve hediye değilse
        if (mainProductInCart && !giftProductInCart) {
          actionsNeeded.push({
            action: 'add',
            rule: rule,
            quantity: mainProductInCart.quantity
          });
        } 
        // Ana ürün ve hediye sepette, ama miktarları eşleşmiyorsa
        else if (mainProductInCart && giftProductInCart && 
                mainProductInCart.quantity !== giftProductInCart.quantity) {
          actionsNeeded.push({
            action: 'update',
            itemId: giftProductInCart.id,
            quantity: mainProductInCart.quantity
          });
        }
      });
      
      // Eğer herhangi bir işlem yapılacaksa, sırayla yap
      if (actionsNeeded.length > 0) {
        processActions(actionsNeeded, 0);
      } else {
        isProcessing = false;
      }
    })
    .catch(error => {
      console.error('Sepet bilgisi alınamadı:', error);
      isProcessing = false;
    });
}

// İşlemleri sırayla gerçekleştir
function processActions(actions, index) {
  if (index >= actions.length) {
    isProcessing = false;
    return;
  }
  
  const action = actions[index];
  
  let promise;
  
  if (action.action === 'add') {
    promise = addGiftToCart(action.rule, action.quantity);
  } else if (action.action === 'update') {
    promise = updateGiftQuantity(action.itemId, action.quantity);
  } else {
    // Tanımlanmamış eylemler için boş promise
    promise = Promise.resolve();
  }
  
  promise.then(() => {
    // Bir sonraki işleme geç, ama önce biraz bekle
    setTimeout(() => {
      processActions(actions, index + 1);
    }, 500);
  }).catch(() => {
    // Hata olsa bile devam et
    setTimeout(() => {
      processActions(actions, index + 1);
    }, 500);
  });
}

function addGiftToCart(rule, quantity = 1) {
  console.log(`${rule.giftName} hediye olarak ekleniyor...`);

  const formData = {
    'items': [{
      'id': rule.giftProductId,
      'quantity': quantity,
      'properties': {
        '_hediye_urun': rule.giftName,
        '_hediye_icin': rule.mainProductId
      }
    }]
  };

  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`${rule.giftName} eklenemedi: Sunucu hatası`);
    }
    return response.json();
  })
  .then(data => {
    // Gerçekten sepete eklendi mi kontrol et
    const addedItem = data.items?.find(item =>
      item.variant_id.toString() === rule.giftProductId &&
      item.properties?._hediye_urun === rule.giftName
    );

    if (addedItem) {
      showNotification(`"${rule.giftName}" hediye olarak sepetinize eklendi!`);
    }

    return data;
  })
  .catch(error => {
    console.error(`${rule.giftName} eklenemedi:`, error);
    throw error;
  });
}

function updateGiftQuantity(itemId, newQuantity) {
  console.log(`Hediye ürün miktarı güncelleniyor (ID: ${itemId}, Yeni miktar: ${newQuantity})...`);
  
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: itemId,
      quantity: newQuantity
    })
  })
  .then(response => response.json())
  .then(data => {
    console.log('Hediye ürün miktarı güncellendi', data);
    return data;
  })
  .catch(error => {
    console.error('Hediye ürün miktarı güncellenemedi:', error);
    throw error;
  });
}

function showNotification(message) {
  const notification = document.createElement('div');
  notification.className = 'gift-notification';
  notification.innerHTML = message;
  notification.style.cssText = 'position: fixed; top: 20px; right: 20px; background: #4CAF50; color: white; padding: 15px; border-radius: 4px; z-index: 9999; animation: fadeIn 0.3s, fadeOut 0.3s 2.7s forwards;';
  
  document.body.appendChild(notification);
  
  setTimeout(() => {
    if (notification.parentNode) {
      document.body.removeChild(notification);
    }
     window.location.reload(); // Sayfa yenilenir
  }, 2000);
}

// CSS animasyonları
const style = document.createElement('style');
style.innerHTML = `
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-20px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  @keyframes fadeOut {
    from { opacity: 1; transform: translateY(0); }
    to { opacity: 0; transform: translateY(-20px); }
  }
`;
document.head.appendChild(style);